import type { IRoute } from '@/router/helpers'
import { BasicLayout } from '@/layouts'

const route: IRoute = {
  path: 'products',
  Component: BasicLayout,
  children: [
    {
      path: '',
      Component: lazy(() => import('@/views/products/list')),
      meta: { title: '服务产品' },
    },
    {
      path: ':id',
      Component: lazy(() => import('@/views/products/branch')),
      meta: { title: '网点查询' },
    },
    {
      path: 'branch/:id',
      Component: lazy(() => import('@/views/products/detail')),
      meta: { title: '服务详情' },
    },
    {
      path: 'item/:nonce/:id',
      Component: lazy(() => import('@/views/products/detail')),
      meta: { title: '服务详情' },
    },
  ],
}

export default route
